import script from "./VCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./VCard.vue?vue&type=script&setup=true&lang=ts"

import "./VCard.vue?vue&type=style&index=0&id=b3d4ccc0&lang=postcss&scoped=true"

import exportComponent from "/builds/frontend/dsp/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b3d4ccc0"]])

export default __exports__